<script lang="ts">
    import { onMount } from "svelte";
    import { gameManager } from "../../../Phaser/Game/GameManager";
    import type { ChatUser } from "../../Connection/ChatConnection";
    import { chatSearchBarValue, shownRoomListStore } from "../../Stores/ChatStore";
    import type { UserProviderMerger } from "../../UserProviderMerger/UserProviderMerger";
    import UserList from "./UserList.svelte";

    interface Props {
        userProviderMerger: UserProviderMerger;
    }

    let { userProviderMerger }: Props = $props();

    const USERS_BY_ROOM_LIMITATION = 200;

    const gameScene = gameManager.getCurrentGameScene();
    const isMatrixChatEnabled = gameScene.room.isMatrixChatEnabled;

    onMount(() => {
        if ($shownRoomListStore.length === 0) shownRoomListStore.set([gameScene.roomUrl]);
    });

    let usersByRoom = $derived(userProviderMerger.usersByRoomStore);

    // usersByRoomStore groups every connected room/map together (it also backs
    // the cross-map chat directory), but this popup is "who's here" — only
    // users physically on the current map, not the whole world.
    let currentRoomUsers = $derived($usersByRoom.get(gameScene.roomUrl)?.users ?? []);

    const mySpaceUserId = gameScene.connection?.getSpaceUserId();

    let users = $derived(
        currentRoomUsers
            .filter(({ username }) => {
                return username
                    ? username.toLocaleLowerCase().includes($chatSearchBarValue.toLocaleLowerCase())
                    : false;
            })
            .sort((chatUserA: ChatUser, chatUserB: ChatUser) => {
                if (chatUserA.spaceUserId === mySpaceUserId) return -1;
                if (chatUserB.spaceUserId === mySpaceUserId) return 1;
                return chatUserA.username?.localeCompare(chatUserB.username || "") || -1;
            })
            .slice(0, USERS_BY_ROOM_LIMITATION),
    );

    let colCount = $derived(Math.min(users.length, 6));
</script>

<div class="h-full bg-mlight/80 shadow-light rounded-md2 p-6 backdrop-blur-md">
    <div
        class="grid gap-10 min-h-0 overflow-x-hidden overflow-y-auto max-h-[560px]"
        style="grid-template-columns: repeat({colCount}, 1fr)"
    >
        <UserList userList={users} {isMatrixChatEnabled} />
    </div>
</div>
